var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('publice.disclaimer')))]),_c('SanitizedHtml',{attrs:{"htmlContent":_vm.content}}),_c('p',[_vm._v("本网站上的所有信息均仅供参考。本公司对因使用本网站信息所造成的任何损失不承担责任。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }